import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { useState } from 'react';
import EmailCell from './emailCell';
import CreateCell from './createCell';


export default function EmailTable(props){
    const { rows, onEdit, onDelete, onCreate, onCancel } = props;
    const [dense, setDense] = useState(false);


    const headCells = [
        {
            id: "email",
            numeric: false,
            disablePadding: false,
            label: "Email"
        },{
            id: "acc",
            numeric: false,
            disablePadding: false,
            label: "ACC"
            
        },{
            id: "vendas",
            numeric: false,
            disablePadding: false,
            label: "Vendas"
        },
        {
            id: "recebimentos",
            numeric: false,
            disablePadding: false,
            label: "Recebimentos"
        },
        {
            id: "edit",
            numeric: false,
            disablePadding: false,
            label: ""
        },
        {
            id: "delete",
            numeric: false,
            disablePadding: false,
            label: ""
        },
    ]

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }} variant="outlined">
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >
                        <TableHead>
                            <TableCell padding="checkbox">
                            </TableCell>
                            {headCells.map(headCell => (
                                <TableCell
                                    key={headCell.id}
                                    align={headCell.numeric ? 'right' : 'left'}
                                    padding={headCell.disablePadding ? 'none' : 'normal'}
                                >{headCell.label}</TableCell>
                            ))}
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((email, index) => {
                                    if(email.email === ""){
                                        return <CreateCell onSave={onCreate} onCancel={onCancel}/>
                                    }
                                    return <EmailCell email={email} onEdit={onEdit} onDelete={onDelete}/>
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    )
}